import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../..'

const getSteps = (state: RootState) => state.steps
const activeStepIndex = (state: RootState) => state.steps.activeStepIndex
const getCurrentStep = (state: RootState) => {
	return state.steps.steps.length > 0 ? (
		state.steps.steps[state.steps.activeStepIndex]
	) : undefined
}

const getReceiverInformationStep = (state:RootState) =>{
	return state.steps.steps.find(element => element.stepTemplate === 'CUSTOMER_INFORMATION')
}
const getFormSummary = (state: RootState) => {
	return state.steps.formSummary
}

const getTotalSteps = (state: RootState) => {
	return state.steps.steps.length;
}

const getEndScreen = (state: RootState) => {
	return state.steps.endScreen;
}

const getFormSubmissionError = (state: RootState) => {
	return state.steps.formSubmitError;
}



// SELECTORS
export const stepsSelector = createSelector(
    getSteps,
    steps => steps
)

export const activeStepIndexSelector = createSelector(
    activeStepIndex,
    active => active
)

/** Gets the current step data, based on the active step index */
export const currentStepSelector = createSelector(
    getCurrentStep,
    step => step
)
export const receiverInformationStepSelector = createSelector(
    getReceiverInformationStep,
    step => step
)
/** Get the total number of steps in the stepper */
export const totalStepsSelector = createSelector(
    getTotalSteps,
    total => total
)

export const formSummarySelector = createSelector(
    getFormSummary,
    summary => summary
)

export const endScreenSelector = createSelector(
    getEndScreen,
    data => data
)

export const formSubmitErrorSelector = createSelector(
    getFormSubmissionError,
    message => message
)


/** Gets a specific form field in the store */
// export const formSummaryField = createSelector(
// 	getFormSummaryField,
//     field => field,
// 	(state: any, props: any) => {
// 		return state
// 	},
// )
